module.exports = __webpack_public_path__ + "static/planbox-87f55870aab4c712d5a7a514fa4e445c.png";